import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';

const storedToken = localStorage.getItem('token');
const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));

const initialState = {
  user: storedToken ? jwtDecode(storedToken) : null,
  userInfo: storedUserInfo || null,
  token: storedToken || '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.token = action.payload.token;
      state.user = jwtDecode(action.payload.token);
      state.userInfo = action.payload.userInfo;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('userInfo', JSON.stringify(action.payload.userInfo));
    },
    refreshUserInfo: (state, action) => {
      state.userInfo = action.payload;
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
    },
    updateClientConfig: (state, action) => {
      if (state.userInfo) {
        state.userInfo = {
          ...state.userInfo,
          client_config: {
            ...state.userInfo.client_config,
            ...action.payload,
          },
        };
        localStorage.setItem('userInfo', JSON.stringify(state.userInfo));
      }
    },
    logoutUser: (state) => {
      state.user = null;
      state.userInfo = null;
      state.token = null;
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
    },
  },
});

// Export actions
export const { setUser, refreshUserInfo, updateClientConfig, logoutUser } =
  authSlice.actions;

// Export the reducer
export default authSlice.reducer;
